module.exports = __webpack_public_path__ + "013558bc9b644f9dddc189d99671ae1f.svg";